import React from 'react';
import styled from 'astroturf/react';
import { Grid, GridProps } from './Grid';

const Container = styled.div`
  display: flex;
`;

const NoPaddingGrid = styled(Grid)`
  padding: 0 !important;
  z-index: 1;
`;

const PaddingContainer = styled.div`
  flex-grow: 1;
  min-width: 24px;

  @include breakpoint(medium) {
    min-width: 40px;
  }

  @include breakpoint(large) {
    min-width: 64px;
  }
`;

export type GridWrapperProps = GridProps & {
  leftPaddingStyle?: React.CSSProperties;
  rightPaddingStyle?: React.CSSProperties;
  containerClassName?: string;
};

/**
 * Same as Grid, but changes left and right padding to be elements instead.
 * These elements can be styled to match designs more easily, especially
 * when designing pages that have left or right background coloring.
 * @param leftPaddingStyle The left margin component's style
 * @param rightPaddingStyle The right margin component's style
 * @param containerClassName The class name to send to the container
 * @param children The children to render
 * @param gridProps The {@link Grid} props
 */
export const GridWrapper: React.FC<GridWrapperProps> = ({
  leftPaddingStyle,
  rightPaddingStyle,
  containerClassName,
  children,
  ...gridProps
}) => {
  return (
    <Container className={containerClassName}>
      <PaddingContainer style={leftPaddingStyle} />
      <NoPaddingGrid {...gridProps}>{children}</NoPaddingGrid>
      <PaddingContainer style={rightPaddingStyle} />
    </Container>
  );
};
